// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lqzu","type":"styles_type__2vk1K","choices":"styles_choices__nV7vQ"};